export default "__VITE_ASSET__38067933__"